import { SettingsOption } from '@/modules/creator-settings/ui/SettingsOption.tsx'
import { formatNumberWithCommas } from '@/utils/helpers'

interface ReturnOnInvestViewProps {
  returnOnInvest: number | undefined
}

export const ReturnOnInvestView = ({
  returnOnInvest,
}: ReturnOnInvestViewProps) => {
  return (
    <SettingsOption
      title="Return on Invest"
      description="A percentage that shows how much profit you've made compared to what you initially invested"
      mobileVertical
      biggerTitle
    >
      <h3 className="text-2xl font-semibold">
        {returnOnInvest
          ? `${formatNumberWithCommas(returnOnInvest * 100, 2)}%`
          : 'No Data'}
      </h3>
    </SettingsOption>
  )
}
